export default __webpack_public_path__ + "static/media/logo_white.cf5eea59.svg";